import { Navigate, Outlet, useLocation } from "react-router-dom";
import { DASHBOARD_SCREEN_ROUTE } from ".";
const PublicRoutes = () => {
  const data = localStorage.getItem("pharmacyAuthToken");
  let res: any = null;
  if (data !== null) {
    res = JSON.parse(data);
  }
  let location = useLocation();

  if (data) {
    return (
      <Navigate
        to={DASHBOARD_SCREEN_ROUTE}
        state={{ from: location }}
        replace
      />
    );
  }
  return <Outlet />;
};
export default PublicRoutes;
